
import React from 'react';
import Navbar from '@/components/Navbar';
import AuthForm from '@/components/AuthForm';
import { Link } from 'react-router-dom';

const Auth: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <div className="flex flex-1 items-center justify-center bg-keepmore-soft-gray py-12">
        <div className="w-full max-w-md px-4">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold">Welcome to KeepMore</h1>
            <p className="text-gray-600 mt-2">The smarter way to process payments and save on fees</p>
          </div>
          
          <AuthForm />
          
          <div className="mt-8 text-center text-sm text-gray-500">
            <p>
              By continuing, you agree to KeepMore's{' '}
              <Link to="/terms" className="text-keepmore-purple hover:underline">Terms of Service</Link>
              {' '}and{' '}
              <Link to="/privacy" className="text-keepmore-purple hover:underline">Privacy Policy</Link>.
            </p>
          </div>
        </div>
      </div>
      
      <footer className="bg-white py-6 border-t">
        <div className="container mx-auto px-4">
          <div className="text-center text-sm text-gray-500">
            © 2025 KeepMore, Inc. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Auth;
